import { Component, HostListener, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { EmitterService } from '../services/emitter.service';

@Component({
  selector: 'app-search-sticky-bar',
  templateUrl: './search-sticky-bar.component.html',
  styleUrls: ['./search-sticky-bar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SearchStickyBarComponent implements OnInit {
  isOnClickSearch;
  constructor(
    private emitter: EmitterService
  ) { 
    this.emitter.showSearchBar$.subscribe((status) => {
      this.isOnClickSearch = status;
    })
  }

  ngOnInit() {
  }
  
  closeSearchBar() {
    this.emitter.broadCastShowSearchBar(false);
  }
}
